// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/datalign-svgs/WATER.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/datalign-svgs/LANDSCAPE.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/datalign-svgs/LANDSCAPE_REVERSED.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/datalign-svgs/GEOLOGICAL.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/datalign-svgs/GEOLOGICAL_REVERSED.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/datalign-svgs/GAS_WELLS.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/images/datalign-svgs/GAS_WELLS_REVERSED.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/images/datalign-svgs/BIODIVERSITY.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/images/datalign-svgs/BIODIVERSITY_REVERSED.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/images/datalign-svgs/COMPLIANCE.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/images/datalign-svgs/COMPLIANCE_REVERSED.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i-datalign-water {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-water:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.i-datalign-landscape {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-landscape:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.i-datalign-landscape-rev {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-landscape-rev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.i-datalign-geological {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-geological:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.i-datalign-geological-rev {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-geological-rev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.i-datalign-gas-wells {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-gas-wells:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.i-datalign-gas-wells-rev {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-gas-wells-rev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.i-datalign-biodiversity {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-biodiversity:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.i-datalign-biodiversity-rev {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-biodiversity-rev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.i-datalign-compliance {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-compliance:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.i-datalign-compliance-rev {
  height: 23px;
  width: 23px;
  margin-top: 7px !important;
  margin-left: 2px !important;
}
.i-datalign-compliance-rev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
`, "",{"version":3,"sources":["webpack://./src/components/explorer/styles/extramarkers.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAoD;AACtD;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAiE;AACnE;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAkE;AACpE;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAiE;AACnE;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAA2D;AAC7D;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAoE;AACtE;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,iDAAkE;AACpE","sourcesContent":[".i-datalign-water {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-water:before {\n  content: url(/public/images/datalign-svgs/WATER.svg);\n}\n.i-datalign-landscape {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-landscape:before {\n  content: url(/public/images/datalign-svgs/LANDSCAPE.svg);\n}\n.i-datalign-landscape-rev {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-landscape-rev:before {\n  content: url(/public/images/datalign-svgs/LANDSCAPE_REVERSED.svg);\n}\n.i-datalign-geological {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-geological:before {\n  content: url(/public/images/datalign-svgs/GEOLOGICAL.svg);\n}\n.i-datalign-geological-rev {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-geological-rev:before {\n  content: url(/public/images/datalign-svgs/GEOLOGICAL_REVERSED.svg);\n}\n.i-datalign-gas-wells {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-gas-wells:before {\n  content: url(/public/images/datalign-svgs/GAS_WELLS.svg);\n}\n.i-datalign-gas-wells-rev {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-gas-wells-rev:before {\n  content: url(/public/images/datalign-svgs/GAS_WELLS_REVERSED.svg);\n}\n.i-datalign-biodiversity {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-biodiversity:before {\n  content: url(/public/images/datalign-svgs/BIODIVERSITY.svg);\n}\n.i-datalign-biodiversity-rev {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-biodiversity-rev:before {\n  content: url(/public/images/datalign-svgs/BIODIVERSITY_REVERSED.svg);\n}\n.i-datalign-compliance {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-compliance:before {\n  content: url(/public/images/datalign-svgs/COMPLIANCE.svg);\n}\n.i-datalign-compliance-rev {\n  height: 23px;\n  width: 23px;\n  margin-top: 7px !important;\n  margin-left: 2px !important;\n}\n.i-datalign-compliance-rev:before {\n  content: url(/public/images/datalign-svgs/COMPLIANCE_REVERSED.svg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
